// import {format, subMonths} from 'date-fns'
import dayjs from 'dayjs'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const linkStyle = {
  color: '#601A79',
  marginLeft: '10px',
  textDecoration: 'none',
}

interface FileUploadInfoProps {
  validateMonthsTill?: number
}

const FileUploadInfo: FunctionComponent<FileUploadInfoProps> = ({ validateMonthsTill = 6 }) => {
  const [endMonth, setEndMonth] = useState('')
  const [startMonth, setStartMonth] = useState('')
  useEffect(() => {
    setEndMonth(dayjs().subtract(1, 'month').format('MMM YY'))
    setStartMonth(dayjs().subtract(validateMonthsTill, 'month').format('MMM YY'))
  }, [])

  return (
    <div>
      <ul className='fs-4'>
        <li>
          PDFs (not scanned copies) of company's operating bank current accounts statements for the
          past 6 months. Example: If today is {dayjs().format('DD MMM YYYY')}, then please upload
          bank statements from {startMonth} to {endMonth} (both months inclusive).
        </li>
        <li>
          If your company is multi-banked, then please upload 6 months bank statements for each bank
          account.
        </li>
        <li>
          If your file is password protected, we request you to remove the password and upload the
          file to avoid submission failure.
        </li>
        <li>
          Please export or download your bank statement in a single currency from your banking
          portal before uploading. Multi-currency statements may cause upload errors.
        </li>
        <li>
          In case if you are facing any issue while uploading bank statements, please contact us on{' '}
          <a
            href='mailto:loansupport@ccrpartners.co'
            style={{ fontWeight: 'bold' }}
            className='text-primary-dark text-decoration-underline'
          >
            loansupport@ccrpartners.co
          </a>
          .
        </li>
      </ul>
    </div>
  )
}

export default FileUploadInfo
